module.exports = __webpack_public_path__ + "img/1.fea6e794.png";